import {Injectable} from '@angular/core';
import {TransmissionService} from "./transmission.service";
import {HttpClient} from "@angular/common/http";
import {HttpErrorHandlerService} from "../http-error-handler.service";
import {JWTService} from "../../authentication/jwt.service";
import {PasteboxService} from "../../services/pastebox.service";
import {RaintreeResponse} from "../interface/raintree-response";
import {OrderFeedback} from "../../profile/interface/order-feedback";
import {RequestMapperService} from "../../request-mapper.service";
import {ConstantService} from "../../services/constant.service";
import {OrderFeedbackResponse} from "../interface/order-feedback-response";

@Injectable({
	providedIn: 'root'
})
export class OrderFeedbackTransmissionService extends TransmissionService {

	constructor(
		_http: HttpClient,
		_httpErrorHandler: HttpErrorHandlerService,
		_jwt: JWTService,
		_pastebox: PasteboxService
	) {
		super(
			_http,
			_httpErrorHandler,
			_jwt,
			_pastebox
		);
	}

	public addOrderFeedback(
		payload: OrderFeedback,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void {

		this.executePostPayload(
			RequestMapperService.ADD_ORDER_FEEDBACK,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			true
		);
	}

	public updateOrderFeedback(
		url: string,
		payload: OrderFeedback,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void {

		this.executePatchPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			true
		);
	}


	public getOrderFeedbackByOrderId(
		id: number,
		onPreExecute: () => void,
		onPostExecute: (response: OrderFeedback) => void,
		onSuccess: (response: OrderFeedback) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	): void {

		this.executeGetPayload<OrderFeedbackResponse, OrderFeedback>(
			RequestMapperService.GET_ORDER_FEEDBACK_BY_ORDER + id,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			ConstantService.ORDER_FEEDBACK_ATTRIBUTE_KEY,
			true
		);

	}
}
